import { z } from 'zod';
import { systemSchema } from './common/systems.js';
export const OUTBOUND_ADMIN_PATH = '/outbound-subscriptions';
export const OUTBOUND_ADMIN_PATHS = {
    list: OUTBOUND_ADMIN_PATH,
    update: `${OUTBOUND_ADMIN_PATH}/{id}`,
    state: `${OUTBOUND_ADMIN_PATH}/{id}/state`,
    deliveries: `${OUTBOUND_ADMIN_PATH}/{id}/deliveries`,
};
function parseTarget(value) {
    try {
        return new URL(value);
    }
    catch {
        return null;
    }
}
export const outboundTargetUrlSchema = z
    .string()
    .max(2048)
    .url()
    .refine((value) => {
    const url = parseTarget(value);
    if (!url)
        return false;
    const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
    return ((url.protocol === 'https:' || (local && url.protocol === 'http:')) &&
        !url.username &&
        !url.password &&
        !url.search &&
        !url.hash);
}, 'Usa HTTPS sin credenciales, parámetros ni fragmentos (HTTP sólo en localhost).');
export const outboundSubscriptionWriteSchema = z
    .object({
    eventType: z
        .string()
        .trim()
        .min(1)
        .max(128)
        .regex(/^[a-zA-Z0-9_.-]+$/),
    system: systemSchema,
    targetUrl: outboundTargetUrlSchema,
    active: z.boolean(),
    // Omitir conserva el secreto; nunca se devuelve el valor almacenado.
    secret: z
        .string()
        .min(1)
        .max(4096)
        .refine((s) => s.trim().length > 0, 'Ingresa un secreto válido.')
        .optional(),
})
    .strict()
    .superRefine((data, ctx) => {
    const url = parseTarget(data.targetUrl);
    if (!url)
        return; // El schema del campo ya registra la URL inválida.
    const path = url.pathname;
    if (data.eventType === 'crm.customer.snapshot' &&
        (data.system !== 'decorapos' || path !== '/webhooks/clientes')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['targetUrl'],
            message: 'Clientes requiere DecoraPOS y la ruta /webhooks/clientes.',
        });
    }
    if (data.system === 'decorapos' &&
        ['order.status.changed', 'order.documents.updated', 'order.canceled'].includes(data.eventType) &&
        path !== '/webhooks/pedidos') {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['targetUrl'],
            message: 'Pedidos requiere la ruta /webhooks/pedidos.',
        });
    }
});
export const outboundSubscriptionStateSchema = z.object({ active: z.boolean() }).strict();
export const outboundSubscriptionViewSchema = z
    .object({
    id: z.string().uuid(),
    eventType: z.string(),
    system: systemSchema,
    targetUrl: z.string(),
    active: z.boolean(),
    hasSecret: z.boolean(),
    authentication: z.enum(['hmac', 'api_key']),
    createdAt: z.string().datetime(),
})
    .strict();
export const outboundDeliveryPageQuerySchema = z
    .object({
    page: z.coerce.number().int().min(1).max(100000).default(1),
})
    .strict();
export const outboundDeliveryPageSchema = z
    .object({
    items: z.array(z
        .object({
        id: z.string().uuid(),
        messageId: z.string().uuid(),
        status: z.enum(['pending', 'delivered', 'failed']),
        attempts: z.number().int(),
        lastError: z.string().nullable(),
        createdAt: z.string().datetime(),
        deliveredAt: z.string().datetime().nullable(),
    })
        .strict()),
    page: z.number().int(),
    hasMore: z.boolean(),
})
    .strict();
//# sourceMappingURL=outbound-admin.js.map